import React, { useMemo, useState, useEffect } from "react";
import { Package, TruckIcon, MapPin, CheckCircle2, Circle, ArrowRight, Calculator, Receipt, TrendingDown } from "lucide-react";
import Summary from "./Summary"; // We'll create this in Step 2
import { useLocation, useNavigate } from "react-router-dom";
import DeliveryGroupingPopup from "./DeliveryGroupingPopup";
import { Layers } from "lucide-react";
import { decryptData } from "../../utils/storageCrypto";

export default function AdminAwardDecision() {
  const location = useLocation();
  const navigate = useNavigate();
  //console.log("RFQ Data from Navigation:", location.state); // Debugging line
  const FetchURL = process.env.REACT_APP_FORE_BRICKBUCKET;
  const { rfq_id, rfq_number } = location.state || {};
  const [selection, setSelection] = useState({});
  const [hoveredCell, setHoveredCell] = useState(null);
  const [rfqSummary, setRfqSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [rfqItems, setRFQItems] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [deliverygroupingPopup, setDeliverygroupingPopup] = useState(false);
  
  const [productCategories, setProductCategories] = useState([]);
  const [PCData, setPCData] = useState([])
 /*  console.log('PCData', PCData);
  console.log('product Categories', productCategories); */
 function chooseVehicle(weight) {
  return vehicles.find(v => weight <= v.maxWeight) || vehicles[vehicles.length - 1];
}

  const fetchAllRFQSummary = async (rfqId) => {
  if (!rfqId) {
    throw new Error("rfqId is required");
  }
 const encryptedToken = sessionStorage.getItem('token');
 const token = decryptData(encryptedToken);

  const FetchURL = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-all-rfq-summary?rfq_id=${rfqId}`;
 
  try {
    const response = await fetch(FetchURL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to fetch RFQ summary");
    }

    return data;
  } catch (error) {
    console.error("Error fetching RFQ summary:", error.message);
    throw error;
  }
};

useEffect(() => {
  if (!rfqItems.length) return;

  const categoryMap = {};

  rfqItems.forEach(item => {
    const categoryId = item.item_category_id;
    if (!categoryId) return;

    if (!categoryMap[categoryId]) {
      categoryMap[categoryId] = {
        product_category_id: categoryId,
        product_category_name: item.item_category_name || "Uncategorized",
        items: []
      };
    }

    categoryMap[categoryId].items.push(item);
  });

  setProductCategories(Object.values(categoryMap));
}, [rfqItems]);



const isCategoryFullySelected = (categoryItems, supplierId) => {
  return categoryItems.every(
    item => selection[item.item_id] === supplierId
  );
};

/* const toggleCategorySelection = (categoryItems, supplierId, supplieritems) => {
  //console.log('supplier Items', supplieritems);
  setSelection(prev => {
    const updated = { ...prev };
    const fullySelected = isCategoryFullySelected(categoryItems, supplierId);

    categoryItems.forEach(item => {
      if (fullySelected) {
        if (updated[item.item_id] === supplierId) {
          delete updated[item.item_id];
        }
      } else {
        updated[item.item_id] = supplierId;
      }
    });

    return updated;
  });
}; */

const toggleCategorySelection = (categoryItems, supplierId, supplierItems = []) => {
  setSelection(prev => {
    const updated = { ...prev };
    const fullySelected = isCategoryFullySelected(categoryItems, supplierId);

    // Build a fast lookup for supplier items
    const supplierItemMap = new Set(
      supplierItems.map(i => i.item_id)
    );

    categoryItems.forEach(item => {
      // Skip items not supplied by this supplier
      if (!supplierItemMap.has(item.item_id)) return;

      if (fullySelected) {
        // Deselect only if currently selected for this supplier
        if (updated[item.item_id] === supplierId) {
          delete updated[item.item_id];
        }
      } else {
        // Select item for this supplier
        updated[item.item_id] = supplierId;
      }
    });

    return updated;
  });
};


  useEffect(() => {
    if (!rfq_id) return;

    const loadRFQSummary = async () => {
      try {
        setLoading(true);
        setError("");

        const data = await fetchAllRFQSummary(rfq_id);
        setRfqSummary(data);
        setRFQItems(data.requested_items); // Assuming data contains items
        setSuppliers(data.supplier_responses); // Assuming data contains suppliers
        setVehicles(data.vehicles_data); // Assuming data contains vehicles
        setPCData(data.product_categorys)
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadRFQSummary();
  }, [rfq_id]);

  // Price matrix logic (unchanged from your code, but memoized for performance)
 const matrix = useMemo(() => {
  return rfqItems.map(item => {
    const prices = suppliers
      .map(supplier => {
        const supplierItem = supplier.response_items.find(
          i => i.item_id === item.item_id
        );

        if (!supplierItem) return null;

        const unitPrice =
          supplierItem.proposed_price > 0
            ? supplierItem.proposed_price
            : supplierItem.requested_price || 0;

        const quantity = item.quantity || 0;

        const total = unitPrice * quantity;

        return {
          supplierId: supplier.vendor_id,
          unitPrice,
          quantity,
          total,
        };
      })
      .filter(Boolean);

    const totals = prices.map(p => p.total);

    return {
      item,
      prices,
      min: totals.length ? Math.min(...totals) : 0,
      max: totals.length ? Math.max(...totals) : 0,
    };
  });
}, [rfqItems, suppliers]);

//console.log("Price Matrix:", matrix); // Debugging line
  // Summary calculation (passed to Summary component)
// Summary calculation (passed to Summary component)
const summary = useMemo(() => {
  let itemsTotal = 0;

  // supplierId -> selected items
  const supplierItemsMap = {};

  Object.entries(selection).forEach(([itemId, supplierId]) => {
    const item = rfqItems.find(i => i.item_id === itemId);
    const supplier = suppliers.find(s => s.vendor_id === supplierId);

    if (!item || !supplier) return;

    const supplierItem = supplier.response_items.find(
      si =>  si.item_id === item.item_id
    );

    if (!supplierItem) return;

    const unitPrice =
      supplierItem.proposed_price > 0
        ? supplierItem.proposed_price
        : supplierItem.requested_price || 0;

    const quantity = item.quantity || 0;
    const itemTotal = unitPrice * quantity;

    itemsTotal += itemTotal;

    if (!supplierItemsMap[supplierId]) {
      supplierItemsMap[supplierId] = [];
    }

    supplierItemsMap[supplierId].push({
      ...item,
      quantity,
      unitPrice,
      itemTotal,
    });
  });

  /* ===================== DELIVERY CALCULATION ===================== */

  let deliveryTotal = 0;
  const deliveries = [];

  Object.entries(supplierItemsMap).forEach(([supplierId, items]) => {
    const supplier = suppliers.find(s => s.vendor_id === supplierId);
    if (!supplier) return;

    const totalWeight = items.reduce(
      (sum, i) => sum + (i.quantity * (i.weightPerUnit || 0)),
      0
    );

    const vehicle = chooseVehicle(totalWeight);
    const cost = vehicle.costPerKm * (supplier.distanceKm || 0);

    deliveryTotal += cost;

    deliveries.push({
      supplier: supplier.company_name || supplier.name || "",
      supplierId,
      vehicle: vehicle.type,
      distance: supplier.distanceKm || 0,
      weight: totalWeight,
      itemCount: items.length,
      cost,
    });
  });

  const selectedCount = Object.keys(selection).length;
  const completionPercentage = rfqItems.length
    ? Math.round((selectedCount / rfqItems.length) * 100)
    : 0;

  return {
    itemsTotal,
    deliveryTotal,
    grandTotal: itemsTotal + deliveryTotal,
    deliveries,
    selectedCount,
    completionPercentage,
  };
}, [selection, rfqItems, suppliers]);


const awardedItems = useMemo(() => {
  return Object.entries(selection).map(([itemId, supplierId]) => {
    const item = rfqItems.find(i => i.item_id === itemId);
    const supplier = suppliers.find(s => s.vendor_id === supplierId);

    if (!item || !supplier) return null;

    const supplierItem = supplier.response_items.find(
      si => si.item_id === item.item_id
    );

    const unitPrice =
      supplierItem?.proposed_price > 0
        ? supplierItem.proposed_price
        : supplierItem?.requested_price || 0;

    return {
      item_id: item.item_id,
      item_name: item.item_name,
      quantity: item.quantity,
      weightPerUnit: item.weightPerUnit || 0,
      supplierId: supplier.vendor_id,
      supplierName: supplier.company_name || supplier.name,
      unitPrice,
      totalWeight: item.quantity * (item.weightPerUnit || 0)
    };
  }).filter(Boolean);
}, [selection, rfqItems, suppliers]);

//console.log("Awarded Items:", awardedItems); // Debugging line

const handleFinalizeAward = ()=>{
  //console.log("Finalize Award Clicked", selection);
  //console.log("Final Summary:", summary);
  setDeliverygroupingPopup(true);
}

const startAwardProcess = async (deliveryGroups) => {
  const salesOrderItems = deliveryGroups.flatMap(g =>
    g.items.map(i => ({
      item_id: i.item_id,
      supplier_id: i.supplierId,
      quantity: i.quantity,
      unit_price: i.unitPrice,
      cost_price: i.unitPrice, 
    }))
  );

  const payload = {
    rfq_id,
    salesorder_items: salesOrderItems,
    delivery_groups: deliveryGroups
  };

  console.log("Final Award Payload:", payload);
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const response = await fetch(`${FetchURL}customer/quotations/manual-award-of-quickbuy-order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
      body: JSON.stringify(payload),
    });

    const responseData = await response.json();
    console.log("Response from Award API:", responseData);

    if (response.ok && responseData.success) {
      alert("RFQ Award Process Initiated Successfully!");
      navigate('/bb/app/rfq/rfqrequirements');
    } else {
      const msg = responseData?.message || `Failed to initiate RFQ award process. (${response.status})`;
      alert("Error: " + msg);
    }
  }

  catch(error){
    console.error("Error initiating RFQ award process:", error);
    alert("An error occurred while initiating the RFQ award process.");
  }
};

return (
  <div className="flex-1 h-[calc(100vh-10px)] bg-gradient-to-br from-slate-100 to-slate-200 px-4 py-6 overflow-hidden">

    {/* ===================== HEADER ===================== */}
    <div className="bg-gray-100 text-[#00000] rounded-xl py-4 px-6 mb-4 shadow-lg">
      <h1 className="text-lg font-bold flex items-center gap-3">
        <Calculator className="text-blue-400" />
        {rfq_number || "RFQ"} Award Decision – Admin View
      </h1>

      <p className="text-[#00000] mt-1 text-sm">
        Assign suppliers category-wise to optimize cost and logistics.
      </p>

      <div className="mt-3">
        <div className="flex justify-end text-xs mb-1">
          <span>{summary.completionPercentage}% Completed</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-blue-500 h-2 rounded-full transition-all"
            style={{ width: `${summary.completionPercentage}%` }}
          />
        </div>
      </div>
    </div>

    {/* ===================== MAIN GRID ===================== */}
    <div className="grid grid-cols-[3fr_1fr] gap-4 h-[calc(100%-120px)]">

      {/* ===================== SUPPLIER MATRIX ===================== */}
      <div className="bg-white rounded-xl shadow border flex flex-col overflow-hidden">

        {/* ===================== HORIZONTAL SCROLL WRAPPER ===================== */}
        <div className="overflow-x-auto">

          {/* This container guarantees SAME WIDTH for header + body */}
          <div
            className="min-w-max"
            style={{
              width: 280 + suppliers.length * 220
            }}
          >

            {/* ===================== STICKY HEADER ===================== */}
            <div
              className="sticky top-0 z-30 bg-gray-100 text-[#00000] grid border-b border-gray-100"
              style={{
                gridTemplateColumns: `280px repeat(${suppliers.length}, 220px)`
              }}
            >
              {/* Items Header */}
              <div className="px-4 py-4 font-semibold h-[64px] flex items-center">
                Items
              </div>

              {/* Supplier Headers */}
              {suppliers.map(s => (
                <div
                  key={s.vendor_id}
                  className="h-[64px] flex flex-col items-center justify-center px-3 text-center"
                >
                  <div className="text-sm font-medium truncate max-w-[180px]">
                    {s.company_name || s.name}
                  </div>
                  <div className="text-xs text-slate-300 flex items-center gap-1 mt-1">
                    <MapPin size={12} />
                    {s.distanceKm || 0} km
                  </div>
                </div>
              ))}
            </div>

            {/* ===================== BODY (VERTICAL SCROLL) ===================== */}
            <div className="max-h-[calc(100vh-300px)] overflow-y-auto">

              {productCategories.map(category => (
                <div key={category.product_category_id} className="border-b">

                  {/* ===================== CATEGORY ROW ===================== */}
                  <div
                    className="bg-white grid items-center border-t"
                    style={{
                      gridTemplateColumns: `280px repeat(${suppliers.length}, 220px)`
                    }}
                  >
                    <div className="px-4 py-3 font-semibold flex items-center gap-2">
                      <Layers size={16} />
                      {category.product_category_name}
                      <span className="text-xs text-slate-500">
                        ({category.items.length})
                      </span>
                    </div>

                    {suppliers.map(supplier => (
                      <div
                        key={supplier.vendor_id}
                        className="flex justify-center items-center"
                      >
                        <input
                          type="checkbox"
                          className="w-4 h-4 accent-blue-600"
                          checked={isCategoryFullySelected(
                            category.items,
                            supplier.vendor_id
                          )}
                          onChange={() =>
                            toggleCategorySelection(
                              category.items,
                              supplier.vendor_id,
                              supplier.response_items
                            )
                          }
                        />
                      </div>
                    ))}
                  </div>

                  {/* ===================== ITEMS ===================== */}
                  {matrix
                    .filter(row =>
                      category.items.some(
                        i => i.item_id === row.item.item_id
                      )
                    )
                    .map(row => (
                      <div
                        key={row.item.item_id}
                        className="grid border-t"
                        style={{
                          gridTemplateColumns: `280px repeat(${suppliers.length}, 220px)`
                        }}
                      >
                        {/* Item */}
                        <div className="px-4 py-3">
                          <div className="font-medium">
                            {row.item.item_name}
                          </div>
                          <div className="text-xs text-slate-500">
                            Qty {row.item.quantity} • {row.item.UOM}
                          </div>
                        </div>

                        {/* Supplier Prices */}
                        {suppliers.map(supplier => {
                          const price = row.prices.find(
                            p => p.supplierId === supplier.vendor_id
                          );

                          const isSelected =
                            selection[row.item.item_id] ===
                            supplier.vendor_id;

                          const isBest =
                            price &&
                            price.total === row.min &&
                            row.min !== row.max;

                          if (!price) {
                            return (
                              <div
                                key={supplier.vendor_id}
                                className="py-3 text-center text-slate-300"
                              >
                                —
                              </div>
                            );
                          }

                          return (
                            <div
                              key={supplier.vendor_id}
                              className={`py-3 px-2 text-center cursor-pointer transition
                                ${
                                  isSelected
                                    ? "bg-blue-50 border-l-4 border-blue-500"
                                    : "hover:bg-slate-50"
                                }
                              `}
                              onClick={() =>
                                setSelection(prev => ({
                                  ...prev,
                                  [row.item.item_id]: supplier.vendor_id
                                }))
                              }
                            >
                              <div className="flex flex-col items-center gap-1">
                                {isSelected ? (
                                  <CheckCircle2
                                    size={18}
                                    className="text-blue-600"
                                  />
                                ) : (
                                  <Circle
                                    size={18}
                                    className="text-slate-300"
                                  />
                                )}
                                <div className="text-xs">
                                  ₹{price.unitPrice} × {row.item.quantity}
                                </div>
                                <div className="font-medium">
                                  ₹{price.total}
                                  {isBest && (
                                    <span className="ml-2 text-xs text-green-600 font-bold">
                                      Best
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ===================== SUMMARY ===================== */}
      <Summary
        summary={summary}
        FinalizeAward={handleFinalizeAward}
      />
    </div>

    {/* ===================== DELIVERY GROUPING ===================== */}
    <DeliveryGroupingPopup
      open={deliverygroupingPopup}
      onClose={() => setDeliverygroupingPopup(false)}
      awardedItems={awardedItems}
      suppliersData={suppliers}
      vehicles={vehicles}
      onConfirm={startAwardProcess}
    />
  </div>
);



}
